import FormField from "./FormField";
import LengthValidator from "./validators/LengthValidator";

export default class TextField extends FormField {
  constructor(minLength = 0, maxLength = 64, isOptional = false, initialValue = '', feature = undefined) {
    super(isOptional, initialValue, feature);
    this._validators = [new LengthValidator(minLength, maxLength)];
  }
}
